module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/chevron-down.svg?dcc93851207c10f484ebc223dae97308";